import { NotOverridableComponentProps } from '../../../../../model/Component'
import { TranslatableBox, TranslatableBoxProps } from '../../../../../feature/localization/component/atom/TranslatableBox'

export type AppUnstyledButtonProps = NotOverridableComponentProps<TranslatableBoxProps>

export function AppUnstyledButton(props: AppUnstyledButtonProps) {
  return <TranslatableBox component={'button'} {...props} />
}
